"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_EVENT = void 0;
exports["default"] = sendEvent;
var SEND_EVENT = 'WEB_CHAT/SEND_EVENT';
exports.SEND_EVENT = SEND_EVENT;
function sendEvent(name, value) {
  return {
    type: SEND_EVENT,
    payload: {
      name: name,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX0VWRU5UIiwiZXhwb3J0cyIsInNlbmRFdmVudCIsIm5hbWUiLCJ2YWx1ZSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2VuZEV2ZW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFTkRfRVZFTlQgPSAnV0VCX0NIQVQvU0VORF9FVkVOVCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNlbmRFdmVudChuYW1lLCB2YWx1ZSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFTkRfRVZFTlQsXG4gICAgcGF5bG9hZDogeyBuYW1lLCB2YWx1ZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFTkRfRVZFTlQgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFVBQVUsR0FBRyxxQkFBcUI7QUFBQ0MsT0FBQSxDQUFBRCxVQUFBLEdBQUFBLFVBQUE7QUFFMUIsU0FBU0UsU0FBU0EsQ0FBQ0MsSUFBSSxFQUFFQyxLQUFLLEVBQUU7RUFDN0MsT0FBTztJQUNMQyxJQUFJLEVBQUVMLFVBQVU7SUFDaEJNLE9BQU8sRUFBRTtNQUFFSCxJQUFJLEVBQUpBLElBQUk7TUFBRUMsS0FBSyxFQUFMQTtJQUFNO0VBQ3pCLENBQUM7QUFDSCJ9